/* src/app/features/renuncia/tarefas/listagem-janela/listagem-janela.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.desabilita {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=listagem-janela.component.css.map */
